import React from 'react';
import { SearchResultsContainer } from '@styles/search-layout';
import styled from '@emotion/styled';
import { mq } from '@styles/breakpoints';

interface FiltersLayoutProps {
  filters: React.ReactNode;
  children: React.ReactNode;
  filtersPosition: 'left' | 'right';
}

export const FiltersWrapper = styled.div({
  top: '100px',
  display: 'none',
  [mq.medium]: {
    display: 'block',
    width: '400px'
  }
});

export const FiltersLayout = ({ filters, children, filtersPosition }: FiltersLayoutProps) => {
  return (
    <>
      {filtersPosition === 'left' && <FiltersWrapper>{filters}</FiltersWrapper>}

      <SearchResultsContainer>{children}</SearchResultsContainer>

      {filtersPosition === 'right' && <FiltersWrapper>{filters}</FiltersWrapper>}
    </>
  );
};
